import React, { Component } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import { Link } from "react-router-dom";
import CustomHelmet from "../components/CustomHelmet";

export default class RegisterThanks extends Component {
  render() {
    return (
      <div>
        <CustomHelmet page="Sucessful" />
        <div className="wrapper login_banner position-relative">
          <div className="overlay">
            <Navbar />

            <div className="banner">
              <div className="text-center mt-6 container">
                <div className="row">
                  <div className="col-3"></div>
                  <div className="col-md-6 col-sm-12">
                    <h1 className="mb-3">Your Registration Was Successful.</h1>
                    <p>
                      Thank you{" "}
                      <span className="text-capitalize">
                        {this.props.match.params.name}
                      </span>{" "}
                      for registering. Kindly go to the{" "}
                      <Link
                        className="text-grey succesful-btn font-weight-bold text-capitalize"
                        to="/login"
                      >
                        log in
                      </Link>{" "}
                      page to continue
                    </p>
                  </div>
                  <div className="col-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
